import ServicosService from "../ServicosService";

export default {
  mixins: [ServicosService],
  data() {
    return {
      idRnpPrestador: -1,
      clickSwitch: false,
      listaPublicoAlvo: [],
      id: this.servico.id
    };
  },
  beforeMount() {
    this.inicializarPublicoAlvo();
    this.recuperarIdRnpPrestador();
  },
  props: {
    servico: {
      type: Object,
      required: true
    },
    dadosServidor: {
      type: Object
    }
  },
  computed: {
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  },
  methods: {
    toggleSwitch() {
      this.clickSwitch = !this.clickSwitch;
    },
    recuperarIdRnpPrestador() {
      const { id } = this.$route.params;
      this.idRnpPrestador = id;
    },
    inicializarPublicoAlvo() {
      return this.getPublicoAlvo(this.id).then(({ data }) => {
        if (data) {
          this.listaPublicoAlvo = [...data];
        }
      });
    },
    atualizarServicoPublico(valor) {
      this.payload.tipoServicoPublico = valor;
    },
    preencheCampo(campo, payload) {
      if (payload == null) return;
      if (campo === "publico") {
        this.payload.tipoServicoPublico.push(payload);
      }
      if (campo === "abrangencia") {
        this.payload.tipoServicoAbrangencia.push(payload);
      }
      if (campo === "especialidade") {
        this.payload.tipoServicoEspecialidade.push(payload);
      }
      if (campo === "outro") {
        this.payload.outro = payload;
      }
      if (campo === "leitos") {
        this.payload.numeroLeitosObservacao = payload;
      }
      if (campo === "especialidades oferecidas") {
        this.payload.especialidadesOferecidas = payload;
      }
    },
    emitPayload(payloadModificado) {
      this.$emit("colher-payload", payloadModificado);
    },
    emitir() {
      if (!this.outrosOpcao) {
        this.payload.outro = "";
      }
      this.emitPayload({ ...this.payload, clickSwitch: this.clickSwitch });
    }
  },
  watch: {
    clickSwitch(newVal) {
      if (!newVal) {
        this.payload.tipoServicoEspecialidade = [];
        this.payload.tipoServicoPublico = null;
        this.payload.tipoServicoAbrangencia = [];
        this.payload.especialidadesOferecidas = "";
        this.payload.numeroLeitosObservacao = "";
        this.payload.outro = "";
      }

      this.$emit("switch", {
        clickSwitch: newVal,
        tipoServico: this.payload.tipoServico
      });
    },
    "payload.tipoServicoEspecialidade": function() {
      if (!this.payload.tipoServicoEspecialidade) {
        return (this.outrosOpcao = false);
      }

      let arr = [];
      this.payload.tipoServicoEspecialidade.map(el => {
        arr.push(el.tipoServicoEspecialidade);
      });
      arr.find(especialidades => {
        if (especialidades.includes("Outro")) {
          this.outrosOpcao = true;
          return true;
        } else {
          this.outrosOpcao = false;
          return false;
        }
      });
      this.emitir();
    }
  }
};
